<template>
  <div>
    <vb-form-row item-name="氏名" :required="true">
      <template #input>
        <v-sheet class="col-6 pa-0 pr-3">
          <validation-provider v-slot="{ errors, invalid }" name="姓" rules="required|max:12|jis_level2_char"
                               mode="passive" ref="lastname">
            <v-text-field
              :value="formItemsGetter.lastname"
              @input="formItemsSetter({name:'lastname', value: $event})"
              @blur="$refs.lastname.validate(); blurBgColorChange($event, errors[0]);"
              @focus="focusBgColorChange($event, errors[0])"
              name="lastname"
              :error-messages="errors"
              outlined
              required
              dense
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              height="44px"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">姓</span></template>
            </v-text-field>
          </validation-provider>
        </v-sheet>
        <v-sheet class="col-6 pa-0 pl-3">
          <validation-provider v-slot="{ errors, invalid }" name="名" rules="required|max:12|jis_level2_char"
                               mode="passive" ref="firstname">
            <v-text-field
              :value="formItemsGetter.firstname"
              @input="formItemsSetter({name:'firstname', value: $event})"
              @blur="$refs.firstname.validate(); blurBgColorChange($event, errors[0]);"
              @focus="focusBgColorChange($event, errors[0])"
              name="firstname"
              :error-messages="errors"
              outlined
              required
              dense
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              height="44px"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">名</span></template>
            </v-text-field>
          </validation-provider>
        </v-sheet>
      </template>
    </vb-form-row>

    <vb-form-row item-name="カナ" :required="true">
      <template #input>
        <v-sheet class="col-6 pa-0 pr-3">
          <validation-provider v-slot="{ errors, invalid }" name="セイ" rules="required|max:12|katakana"
                               ref="lastnameKatakana">
            <v-text-field
              :value="lastnameKatakana"
              @change="setLastnameKatakana($event)"
              @blur="setLastnameKatakana($event.target.value); blurBgColorChange($event, errors[0]);"
              @focus="focusBgColorChange($event, errors[0])"
              :key="keys.lastnameKatakana"
              name="lastnameKatakana"
              :error-messages="errors"
              label="セイ"
              outlined
              required
              dense
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              height="44px"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">セイ</span></template>
            </v-text-field>
          </validation-provider>
        </v-sheet>
        <v-sheet class="col-6 pa-0 pl-3">
          <validation-provider v-slot="{ errors, invalid }" name="メイ" rules="required|max:12|katakana"
                               ref="firstnameKatakana">
            <v-text-field
              :value="firstnameKatakana"
              @change="setFirstnameKatakana($event)"
              @blur="setFirstnameKatakana($event.target.value); blurBgColorChange($event, errors[0]);"
              @focus="focusBgColorChange($event, errors[0])"
              :key="keys.firstnameKatakana"
              name="firstnameKatakana"
              :error-messages="errors"
              label="メイ"
              required
              outlined
              dense
              :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
              height="44px"
              hide-details="auto"
              solo
              flat
            >
              <template #label><span class="text-body-2">メイ</span></template>
            </v-text-field>
          </validation-provider>
        </v-sheet>
      </template>
    </vb-form-row>
  </div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
import InputValueConversion from "../../../libs/InputValueConversion.js";
export default {
  name: "vb-names",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      keys: {
        lastnameKatakana: '',
        firstnameKatakana: '',
      },
    }
  },
  methods: {
    setLastnameKatakana(v) {
      this.lastnameKatakana = v;
    },
    setFirstnameKatakana(v) {
      this.firstnameKatakana = v;
    },
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    toKana(value) {
      return InputValueConversion.toKana(value);
    },
  },
  computed: {
    lastnameKatakana: {
      get() {
        return this.formItemsGetter.lastnameKatakana;
      },
      set(v) {
        this.keys.lastnameKatakana = v + Math.random();
        this.formItemsSetter({
          name: 'lastnameKatakana',
          value: this.toKana(v)
        });
      }
    },
    firstnameKatakana: {
      get() {
        return this.formItemsGetter.firstnameKatakana;
      },
      set(v) {
        this.keys.firstnameKatakana = v + Math.random();
        this.formItemsSetter({
          name: 'firstnameKatakana',
          value: this.toKana(v)
        });
      }
    },
  }
}
</script>

<style scoped>

</style>